export function getOrientation(): "portrait" | "landscape" {
  const {width, height} = getWindowDimensions();
  return height > width ? "portrait" : "landscape";
}

export function isInPortraitOrientation(): boolean {
  return getOrientation() === "portrait";
}

export function isInLandscapeOrientation(): boolean {
  return getOrientation() === "landscape";
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height};
}